import { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { useMediaQuery } from '@lsy-netline-ui/netline-ui';

import MultiColumnContext from './MultiColumnContext';

const VERTICAL_BREAKPOINT = 450;

const MultiColumnProvider = ({ children }: { children: React.ReactNode }) => {
  const bigScreen = useMediaQuery(
    (theme: any) => `(min-width: ${theme.breakpoints.values.sm}px) and (min-height: ${VERTICAL_BREAKPOINT}px)`,
  );
  const landscape = useMediaQuery('(orientation: landscape)');
  const multiColumn = (!isMobile || landscape) && bigScreen;

  return <MultiColumnContext.Provider value={multiColumn}>{children}</MultiColumnContext.Provider>;
};

export const useMultiColumn = () => useContext(MultiColumnContext);

export default MultiColumnProvider;
